// Angular
import { Component, OnInit } from '@angular/core';
// Models
// import { Post } from './../../models/post';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import * as moment from 'moment';
import * as lodash from 'lodash';
import { DatePipe } from '@angular/common';
import { ApiService } from './../../services/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { OAuthService } from './../../services/o-auth';
import { Order } from './../../models/order'
import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseApp } from 'angularfire2';
import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    templateUrl: './attachments.component.html'
})
export class AttachmentsComponent implements OnInit {
    public orders: any = [];


    public form: FormGroup;
    public isReset = false
    public date: any;
    public order = 'createdAt';
    public imageLoader = true;
    public filterargs: any;
    public attachmentFiles: any;
    constructor(public sanitizer: DomSanitizer, private fireDatabase: AngularFireDatabase, private firebase: FirebaseApp, private datePipe: DatePipe,
        private oAuthService: OAuthService, private apiService: ApiService, private fireAuth: AngularFireAuth, private http: Http) {
        this.filterargs = {name:""};


    }
    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl('', Validators.required),
            desc: new FormControl('', Validators.required)
        });
        this.initOffersList(this.sanitizer);
    }

    initOffersList(sanitizer) {
        this.imageLoader = true;
        const club = this.fireAuth.auth.currentUser.uid;
        const fireObject = this.fireDatabase.object(`/admin-attachments`)
            .subscribe(result => {
                if (result){
                    this.orders = [];
                    lodash.forEach(result, (item, key) => {
                        if (item) {
                            item.$key = key;
                            var urls = []
                            if (item.fileUrls) {
                                lodash.forEach(item.fileUrls, (fileUrl, key) => {

                                    var xhr = new XMLHttpRequest();
                                    xhr.responseType = 'blob';
                                    xhr.onload = function (event) {
                                        var blob = xhr.response;
                                        var obj = {
                                            type: "",
                                            showUrl: fileUrl,
                                            downloadUrl: sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob))
                                        }
                                        if (blob.type.match('image.*')) {
                                            obj.type = "image"
                                        } else if (blob.type.match('video.*')) {
                                            obj.type = "video"

                                        } else if (blob.type.match('application/pdf')) {
                                            obj.type = "pdf"

                                        } else {
                                            obj.type = "other"

                                        }
                                        console.log(urls, item)

                                        urls.push(obj)

                                    };

                                    xhr.open('GET', fileUrl);
                                    xhr.send();

                                })
                            }
                            item.urls = urls
                            this.orders.push(item)

                        }
                    });
                }
            });

        this.imageLoader = false;
    }

    private uploadFile(): Promise<any> {
        var promises = []
        if (this.attachmentFiles) {

            for (var i = 0; i < this.attachmentFiles.length; i++) {
                const element = this.attachmentFiles[i];
                const newImage = new Promise((resolve, reject) => {
                    const filename = `${moment().unix()}.${Math.floor(Math.random() * (900) + 100)}`;
                    this.firebase.storage().ref(`/attachments/${this.fireAuth.auth.currentUser.uid}`).child(filename)
                        .put(element.file)
                        .then(result => resolve(result))
                        .catch(error => reject(error));

                });
                promises.push(newImage)
            }
        }



        return Promise.all(promises)
    }

    public changeAttachment(attachments) {
        this.attachmentFiles = attachments

    }

    public submit() {
        this.uploadFile().then((results) => {
            var urls = []
            for (var i = 0; i < results.length; i++) {
                var element = results[i];
                urls.push(element.downloadURL)

            }
            var obj = {
                name: this.form.controls['name'].value,
                desc: this.form.controls['desc'].value,
                createdAt: new Date().getTime() / 1000,
                fileUrls: urls

            }
            this.apiService.push("admin-attachments", obj).then((data) => {
                $('#myModal23').modal('hide');
                this.form.reset()
                this.isReset = true
                this.attachmentFiles = []
            })
        })
    }

    public delete(key) {
        if (confirm('Are you sure? you want to delete this attachment')) {
            this.apiService.set("admin-attachments/" + key, null).then((data) => {
                console.log(data)

            })
        }

    }

}

